import { createRouter, createWebHistory } from 'vue-router'
import DashboardLayout from '../layouts/DashboardLayout.vue'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import InboxView from '../views/InboxView.vue'
import SentView from '../views/SentView.vue'
import ArchiveView from '../views/ArchiveView.vue'
import DraftsView from '../views/DraftsView.vue'
import DepartmentsView from '../views/DepartmentsView.vue'
import UsersView from '../views/UsersView.vue'
import TemplatesView from '../views/TemplatesView.vue'
import NotesView from '../views/NotesView.vue'
import SettingsView from '../views/SettingsView.vue'
import ProfileView from '../views/ProfileView.vue'

// Settings components
import MailPrioritiesView from '../views/settings/MailPrioritiesView.vue'
import RolesView from '../views/settings/RolesView.vue'
import MailTypesView from '../views/settings/MailTypesView.vue'
import FileTypesView from '../views/settings/FileTypesView.vue'
import DepartmentJobsView from '../views/settings/DepartmentJobsView.vue'
import EmployeeTitlesView from '../views/settings/EmployeeTitlesView.vue'
import MailTemplateCategoriesView from '../views/settings/MailTemplateCategoriesView.vue'

import store from '@/store'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/dashboard',
    component: DashboardLayout,

    children: [
      {
        path: '',
        name: 'dashboard',
        component: DashboardView,
      
      },
      {
        path: 'inbox',
        name: 'inbox',
        component: InboxView,
        meta: { requiresPermission: 'admin.mails.index' }
      },
      {
        path: 'sent',
        name: 'sent',
        component: SentView,
        meta: { requiresPermission: 'admin.mails.index' }
      },
      {
        path: 'archive',
        name: 'archive',
        component: ArchiveView,
        meta: { requiresPermission: 'admin.archive-mails.index' }
      },
      {
        path: 'drafts',
        name: 'drafts',
        component: DraftsView,
        meta: { requiresPermission: 'admin.mails.index' }
      },
      {
        path: 'departments',
        name: 'departments',
        component: DepartmentsView,
        meta: { requiresPermission: 'admin.departments.index' }
      },
      {
        path: 'users',
        name: 'users',
        component: UsersView,
        meta: { requiresPermission: 'admin.users.index' }
      },
      {
        path: 'templates',
        name: 'templates',
        component: TemplatesView,
        meta: { requiresPermission: 'admin.mail-templates.index' }
      },
      {
        path: 'notes',
        name: 'notes',
        component: NotesView,
        meta: { requiresPermission: 'admin.marginalizations.index' }
      },
      {
        path: 'settings',
        name: 'settings',
        component: SettingsView,
        meta: { requiresPermission: 'admin.roles.index' || 'admin.mail-template-categories.index' || 'admin.mail-types.index' || 'admin.mail-priorities.index' || 'admin.file-types.index' || 'admin.employee-titles.index'  }
      },
      {
        path: 'profile',
        name: 'profile',
        component: ProfileView
      },
      {
        path: 'settings/mail-priorities',
        name: 'mail-priorities',
        component: MailPrioritiesView,
        meta: { requiresModule: 'mail-priorities' }
      },
      {
        path: 'settings/roles',
        name: 'roles',
        component: RolesView,
        meta: { requiresModule: 'roles' }
      },
      {
        path: 'settings/mail-types',
        name: 'mail-types',
        component: MailTypesView,
        meta: { requiresModule: 'mail-types' }
      },
      {
        path: 'settings/file-types',
        name: 'file-types',
        component: FileTypesView,
        meta: { requiresModule: 'file-types' }
      },
      {
        path: 'settings/department-jobs',
        name: 'department-jobs',
        component: DepartmentJobsView,
        meta: { requiresModule: 'department-jobs' }
      },
      {
        path: 'settings/employee-titles',
        name: 'employee-titles',
        component: EmployeeTitlesView,
        meta: { requiresModule: 'employee-titles' }
      },
      {
        path: 'settings/mail-template-categories',
        name: 'mail-template-categories',
        component: MailTemplateCategoriesView,
        meta: { requiresModule: 'mail-template-categories' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard to check authentication and permissions
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user')
  
  if (to.name !== 'login' && !isAuthenticated) {
    next({ name: 'login' })
  } else if (to.name === 'login' && isAuthenticated) {
    next({ path: '/dashboard' })
  } else if (to.meta.requiresPermission) {
    // Check if user has required permission
    const userPermissions = store.state.permissions || []
    const hasPermission = userPermissions.includes(to.meta.requiresPermission)
    
    if (!hasPermission) {
      // Redirect to dashboard if no permission
      next({ path: '/dashboard' })
      // Show error message
      store.dispatch('alerts/showAlert', {
        type: 'error',
        message: 'ليس لديك صلاحية للوصول إلى هذه الصفحة'
      })
    } else {
      next()
    }
  } else if (to.meta.requiresModule) {
    // Check if user has required module access
    const modules = store.state.modules || {}
    const hasModuleAccess = !!modules[to.meta.requiresModule]
    
    if (!hasModuleAccess) {
      // Redirect to dashboard if no module access
      next({ path: '/dashboard' })
      // Show error message
      store.dispatch('alerts/showAlert', {
        type: 'error',
        message: 'ليس لديك صلاحية للوصول إلى هذه الصفحة'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router 